// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navigationItem":"Navigation_navigationItem__WcOn0","languageDropdown":"Navigation_languageDropdown__OLOX5"};